// removed by extract-text-webpack-plugin
module.exports = {"error":"_1gF-T0jbXINF-ZzgKEuZdO","greyButton":"_2HSS8uNiARA3RTIEigYprp","informationTitle":"_1OOTX-I56zHg-bv8-EE6dg","informationTitleBorder":"_39NKbJgkMW_Vn0RTueftDk","moduleSection":"lp8whZ78rG728zE8j_Sv9","moduleSectionHeading":"_1J57v6giS-uUgFlB6TSroa","KeyValue":"_1IPSjZSA95RirV9tzt-ad9"};


//////////////////
// WEBPACK FOOTER
// ./components/clients/clientProfileEdit.scss
// module id = 718
// module chunks = 0